import { render, staticRenderFns } from "./Economy.vue?vue&type=template&id=3113de5a&scoped=true&"
import script from "./Economy.vue?vue&type=script&lang=js&"
export * from "./Economy.vue?vue&type=script&lang=js&"
import style0 from "./Economy.vue?vue&type=style&index=0&id=3113de5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3113de5a",
  null
  
)

export default component.exports